import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../emitter/Observer';
import { audiosAssets } from '../../assets/audio';
import { ButtonPlay } from '../../components/common/ButtonPlay';
import { ButtonHome } from '../../components/common/ButtonHome';
import { SelectorCharacterUI } from '../introduction/SelectorCharacterUI';
import { DialogBarNew } from '../../components/common/DialogBarNew';
import { voicesTypeControl } from '../../types/audioType';


const steps = {
	selectCharacter: 1,
	dialogInitial: 2,
	dialogTwo: 3,
	dialogThree: 4,
};

export const Theme3Introduction = () => {
	const { loaded } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(steps.selectCharacter);

	useEffect(() => {
		if (loaded) {
			console.log("theme 3 intro");
			ObserverEmitter.emit(EVENTS.tema3.introduction, 0);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		// ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.introduccion.intro01T3)
	})
	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
			</>
			{uiToShow === steps.selectCharacter && (
				<SelectorCharacterUI
					callback={() => {
						// ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.introduccion.intro01T2)
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.introduccion.intro01T3)
						setUiToShow(steps.dialogInitial);
						ObserverEmitter.emit(EVENTS.move_escritorio_introduction);
					}}
				></SelectorCharacterUI>
			)}
			{uiToShow === steps.dialogInitial && (
				<DialogBarNew
					dialog={
						"¡Te doy la bienvenida a la Tienda Receso! comenzaremos con nuestra siguiente actividad: alimentos, limpieza y merma."
					}
					percentage={"50%"}
					callback={() => {
						// ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.introduccion.intro02T2)
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.introduccion.intro02T3)
						ObserverEmitter.emit(EVENTS.characterAnimations.idle);
						setUiToShow(steps.dialogTwo);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogTwo && (
				<DialogBarNew
					dialog={
						`Durante esta sección, conoceremos las tareas que realiza un Colaborador en Tienda con la finalidad de aplicarlas en su día a día.`
					}
					percentage={"100%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.introduccion.intro03T3)
						setUiToShow(steps.dialogThree)
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogThree && (
				<DialogBarNew
					dialog={
						`Al realizar las tareas y misiones que se presentan durante el recorrido obtendrás puntos que medirán tu aprendizaje.`
					}
					percentage={"100%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						window.location.href = "/home3/tema3/subtema1/activityOne"
					}}
				></DialogBarNew>
			)}
		</>
	)
}
